import { SET_VERSION_INFO } from "./types";
import { getBaseURL } from "../../env/stage";
import { get } from "../../common/modules/http.client";

const VERSION_URL = getBaseURL() + "/api/1/version";

export const fetchVersionInfo = () => async (dispatch: any) => {
  try {
    const response = await get(VERSION_URL);
    dispatch({
      type: SET_VERSION_INFO,
      payload: response,
    });
  } catch (error) {
    console.error("Unable to fetch version info", error);
  }
};
